module.exports = __webpack_public_path__ + "static/img/常规分子项目banner.fa69a65.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/一级标题Banner/常规分子项目banner.jpg
// module id = Jh1K
// module chunks = 16